var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13247_81097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0589 0.945659C13.8053 -0.0626144 15.9569 -0.0626158 17.7033 0.945657L26.94 6.27846C28.6864 7.28674 29.7622 9.1501 29.7622 11.1666V21.8323C29.7622 23.8488 28.6864 25.7122 26.94 26.7204L17.7033 32.0532C15.9569 33.0615 13.8053 33.0615 12.0589 32.0533L2.8222 26.7204C1.07582 25.7122 0 23.8488 0 21.8323V11.1666C0 9.1501 1.07582 7.28674 2.8222 6.27846L12.0589 0.945659Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13247_81097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.877 -0.964844L31.1888 8.45279L22.9339 12.8976L19.5242 11.0377L16.4244 11.3477L8.67499 8.55788L6.81512 11.0377L5.88519 12.2776L4.02533 11.0377L-1.43487 8.45279L14.877 -0.964844Z",
    fill: "url(#paint0_linear_13247_81097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.128906 8.58677L6.19899 11.6554L9.91871 20.6447L9.91871 20.9547L11.1586 22.5046L16.7382 26.8443L14.8802 34.5833L-0.128907 25.9178L-0.128906 8.58677Z",
    fill: "url(#paint1_linear_13247_81097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8341 20.9533L23.8638 12.2739L29.886 8.5877L29.886 25.9187L14.8769 34.5843L14.5645 26.8428L19.8341 20.9533Z",
    fill: "url(#paint2_linear_13247_81097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8763 6.08203C12.3115 6.08203 9.9741 7.05551 8.21323 8.65311L9.6428 20.9608C10.0337 21.1413 12.2759 21.8909 12.7065 21.8909H15.8062C16.3541 21.8909 20.1459 20.7231 20.1459 21.2709L19.8359 19.9689C19.8359 20.5168 19.3919 20.9608 18.844 20.9608H10.9086C10.3608 20.9608 9.91667 20.5168 9.91667 19.9689V15.1669C9.91667 14.7363 9.82323 14.3109 9.6428 13.9198L8.21323 8.65311C6.61563 10.4139 4.95703 13.4365 4.95703 16.0013C4.95703 21.4796 9.39799 25.9206 14.8763 25.9206C20.3546 25.9206 24.7956 21.4796 24.7956 16.0013C24.7956 10.523 20.3546 6.08203 14.8763 6.08203Z",
    fill: "url(#paint3_linear_13247_81097)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0383 10.222C13.2573 10.1374 13.4916 10.1043 13.7236 10.125C13.9555 10.1456 14.179 10.2196 14.3771 10.3413C14.5752 10.463 14.7427 10.6292 14.8669 10.8273C14.9911 11.0254 15.0688 11.2503 15.094 11.4848C15.2741 13.1747 14.8946 14.8858 14.015 16.3494C13.1354 17.8131 11.8056 18.9465 10.2342 19.5717L9.12213 16.6963C10.0608 16.3225 10.8558 15.6465 11.3836 14.7735C11.9114 13.9005 12.1423 12.8795 12.0405 11.8692C12.0034 11.5242 12.0811 11.1748 12.2614 10.8764C12.4417 10.578 12.7142 10.3477 13.0357 10.2219L13.0383 10.222Z",
    fill: "#9C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0263 10.226C12.6465 10.3773 12.3392 10.6745 12.1721 11.0522C12.005 11.4299 11.9917 11.8571 12.1352 12.24L15.3852 20.9069C15.5289 21.2897 15.8175 21.5968 16.1877 21.7605C16.5578 21.9243 16.9792 21.9314 17.3591 21.7803V21.7803C17.5473 21.7054 17.7196 21.594 17.8663 21.4522C18.0129 21.3105 18.131 21.1413 18.2137 20.9542C18.2965 20.7672 18.3423 20.566 18.3486 20.3622C18.3548 20.1583 18.3214 19.9558 18.2503 19.7662L15.0002 11.0994C14.9292 10.9097 14.8218 10.7367 14.6841 10.5902C14.5465 10.4436 14.3813 10.3265 14.1979 10.2453C14.0146 10.1642 13.8168 10.1208 13.6158 10.1175C13.4147 10.1141 13.2144 10.151 13.0263 10.226Z",
    fill: "#9C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3432 21.7836C17.1243 21.8682 16.89 21.9014 16.6581 21.8808C16.4262 21.8602 16.2028 21.7863 16.0047 21.6646C15.8067 21.543 15.6392 21.3769 15.515 21.1788C15.3907 20.9807 15.3131 20.7559 15.2878 20.5214C15.1079 18.8315 15.4874 17.1205 16.3669 15.6568C17.2464 14.1931 18.5761 13.0595 20.1474 12.4339L21.2595 15.3104C20.3208 15.6842 19.5258 16.3602 18.998 17.2332C18.4702 18.1062 18.2393 19.1272 18.3411 20.1375C18.3777 20.4826 18.2994 20.8319 18.1186 21.1301C17.9379 21.4283 17.665 21.6583 17.3432 21.7836V21.7836Z",
    fill: "#9C5AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13247_81097",
    x1: 14.5646,
    y1: 0.498467,
    x2: 14.282,
    y2: 11.8208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E00D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A36F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13247_81097",
    x1: 14.8783,
    y1: 23.4345,
    x2: 5.90272,
    y2: 12.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5508D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7935EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13247_81097",
    x1: 14.8744,
    y1: 24.673,
    x2: 23.4474,
    y2: 13.2139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5205D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A35F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13247_81097",
    x1: 14.8763,
    y1: 6.08203,
    x2: 14.8763,
    y2: 25.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7935EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6117E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.592ae9257d2c32fd74ee56b174bb5fbe.svg";
export { ForwardRef as ReactComponent };